import { IAppState } from '../../../AppModulesWrapper';
import { IPublishTermsService } from '../../types/reducers/publishTerms';
import { selectServiceById } from './selectServiceById';

export function selectActiveService(state: IAppState): IPublishTermsService | null {
  const {
    publishTerms: { selectedServiceId },
  } = state.servicePickerWidget;

  if (!selectedServiceId) {
    return null;
  }

  return selectServiceById(selectedServiceId, state);
}
